<template>
  <!-- 车辆登记 -->
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="160px" size="mini">
        <div class=" formItemBox">
          <el-form-item label="环保登记编码:" prop="vhcRegistCode">
            <el-input  placeholder="" v-model="searchFrom.vhcRegistCode"></el-input>
          </el-form-item>
          <el-form-item label="排放阶段:" prop="standardsId">
            <el-select placeholder="请选择" v-model="searchFrom.standardsId">
              <el-option
                v-for="item in pfbz"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机械环保代码:" prop="vhcMachineCode">
            <el-input  placeholder="" v-model="searchFrom.vhcMachineCode"></el-input>
          </el-form-item>
          <el-form-item label="上报状态 :" prop="reportStatus">
              <el-select v-model="searchFrom.reportStatus" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="待上报" value="0" ></el-option>
                <el-option  label="上报中" value="1" ></el-option>
                <el-option  label="已上报" value="2" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上报时间:" prop="reportTime">
              <el-date-picker
                v-model="searchFrom.reportTimeArr "
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
           <el-form-item label="创建时间:" prop="createTime">
              <el-date-picker
                v-model="searchFrom.createTimeArr"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="00BP007B001"  >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" btnCode="00BP007B001"  @click="addVeicle">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  class="tableComent"
                @row-click="handleRowClick" height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini"  btnCode="00BP007B001"   @click="modifyVeicle(scope.row)">修改</el-button>
              <el-button type="text" size="mini"  btnCode="00BP007B001" v-if="scope.row.reportStatus!=2"  @click="delFN(scope.row)">删除</el-button>
              <el-button type="text" size="mini"  btnCode="00BP007B001"  @click="detailFN(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="reportStatus" label="上报状态">
          <template scope="scope">
            <div>
              <span>{{["待上报", "上报中", "已上报"][scope.row.reportStatus]}}</span>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="reportTime" width="160" :formatter="dateFormat" label="上报时间"></el-table-column>
         <el-table-column property="reportDescribe" min-width="170"  :show-overflow-tooltip="true" label="上报描述"></el-table-column>
        <el-table-column prop="vhcRegistCode"  min-width="220" :show-overflow-tooltip="true" label="环保登记编码"></el-table-column>
         <el-table-column prop="productDate" width="160" :formatter="dateFormat1" label="生产日期"></el-table-column>
        <el-table-column prop="standardsName"  min-width="160"  :show-overflow-tooltip="true" label="排放阶段"></el-table-column>
        <el-table-column prop="vhcMachineCode"  min-width="220" :show-overflow-tooltip="true" label="机械环保代码"></el-table-column>
        <el-table-column prop="createUserName" width="170"   label="创建者"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[25,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1100px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="160px" size="mini">
        <div class="inpBox">
               <el-form-item label="环保登记编码:" prop="vhcRegistCode" >
                <el-input  placeholder="" v-model="addFrom.vhcRegistCode"  maxlength="20"></el-input>
              </el-form-item>
               <el-form-item label="生产日期:" prop="productDate">
                <el-date-picker
                  v-model="addFrom.productDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="排放阶段:"  prop="standards">
                <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standards">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="机械环保代码:" prop="vhcMachineCode" >
                <el-input  placeholder="" v-model="addFrom.vhcMachineCode"  maxlength="20"></el-input>
              </el-form-item>
              <div class="addressBox">
                <h4 class="title">
                  <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>发动机铭牌照片</span>
                </h4>
              </div>
              <div class="imgBox">
                <el-upload
                  action=""
                  :file-list="listImg"
                  ref="upload"
                  :auto-upload="false"
                  :on-change="imgPreview"
                  list-type="picture-card"
                  accept="image/*"
                  :limit="1"
                   :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove" :class="[isAddImg?'hidden':'']">
                </el-upload>
              </div>
           </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="detailMsrk" @close="closeDialog" width="1100px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="160px" size="mini">
        <div class="inpBox">
               <el-form-item label="环保登记编码:" prop="vhcRegistCode" >
                 <div style="width:170px">{{addFrom.vhcRegistCode}}</div>
              </el-form-item>
              <el-form-item label="生产日期:" prop="productDate">
                 <div style="width:170px">{{addFrom.productDate|dateFormat1}}</div>
              </el-form-item>
              <el-form-item label="排放阶段:"  prop="standards">
               <div style="width:170px">{{addFrom.standardsName}}</div>
             </el-form-item>
              <el-form-item label="机械环保代码:" prop="vhcMachineCode" >
                <div style="width:170px">{{addFrom.vhcMachineCode}}</div>
              </el-form-item>
              <div class="addressBox">
                <h4 class="title">
                  <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>发动机铭牌照片</span>
                </h4>
              </div>
              <div class="imgBox" style="width:100%">
               <img width="100%" :src="addFrom.vhcEngineAccessUrl" alt="">
              </div>
           </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailMsrk = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看图片" :visible.sync="lookImgVisible" center="">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { compressImage } from '@/utils/compressImage'
import { noroadinfoList, noroadinfoAdd, noroadinfoUpdate, noroadinfoDelete, cVElist } from '@/api/vgs-driver'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      isDisable: false,
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {
      },
      isAdd: false,
      title: '添加',
      pfbz: [],
      rules: {
        vhcRegistCode: [
          { required: true, message: '请输入环保登记编码', trigger: 'blur' }
          // this.rule.vhcNo
        ],
        productDate: [
          { required: true, message: '请选择生产日期', trigger: 'blur' }
        ],
        standards: [
          { required: true, message: '请输入选择排放阶段', trigger: 'blur' }
        ],
        vhcMachineCode: [
          { required: true, message: '请输入机械环保代码', trigger: 'blur' }
        ]

      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      isAddImg: false,
      listImg: [],
      imgUrl: [],
      imgfile: new FormData(),
      dialogImageUrl: '',
      detailMsrk: false
      // btnFlg: [],
      // btnIdArr: [ '00BP007B001', '00BP007B002',
      //   '00BP007B003', '00BP007B004', '00BP007B005', '00BP007B006']
    }
  },
  created () {
    // this.btnFlg = getBtn(this.btnIdArr, '/vehicleRegister')
    this.getList(this.searchFrom)
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.driverName + '/vehicle/noroadinfo/exportList',
        form,
        '非道路机械台账列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 详情
    detailFN (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.detailMsrk = true
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      noroadinfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      this.listImg = fileList
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg = fileList
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.lookImgVisible = true
    },
    // 添加
    addVeicle () {
      this.title = '添加'
      this.dialogVisible = true
      this.isAdd = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    },
    // 修改
    modifyVeicle (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      if (row.vhcEngineAccessUrl != '') {
        this.$set(this.listImg, 0, { status: 'ready', url: row.vhcEngineAccessUrl, flag: true })
        this.isAddImg = true
      } else {
        this.listImg = []
        this.isAddImg = false
      }
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFrom.standards) {
            if (this.addFrom.standards.id == '') {
              this.addFrom.standardsName = null
            } else {
              this.addFrom.standardsName = this.addFrom.standards.name
            }
            this.addFrom.standardsId = this.addFrom.standards.id
          }
          this.imgfile.set('params', JSON.stringify(this.addFrom))
          let that = this
          if (this.listImg.length > 0) {
            if (!this.listImg[0].flag) {
              compressImage(this.listImg[0].url, this.listImg[0].raw, {
                width: 1000
              }).then(result => {
                that.imgfile.set('vhcEngineFile', result)// result即为压缩后的结果
                this.save1()
              })
            } else {
              this.save1()
            }
          } else {
            this.$alert('', '请上传发动机铭牌照片')
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        noroadinfoAdd(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        noroadinfoUpdate(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 删除
    delFN  (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        noroadinfoDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },

    closeDialog () {
      this.addFrom = {
      }
      this.vhcType = {}
      this.vhcL = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.imgfile.set('vhcEngineFile: ', '')
      this.imgfile.set('params', '')
      this.listImg = []
      this.isAddImg = false
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        registerDates: null
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      if (cellValue) {
        var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
        var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
        var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
        return (
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
        )
      }

      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      let str = ''
      if (cellValue) {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
  .searchBtnBox {
    margin-left: 10px;
  }
  .inpBox .el-date-editor{
    width: 350px!important;
  }
  .imgBox{
    display: flex;
    .item{
      display: flex;
      width: 50%;
      justify-content: space-around;
    }
  }
  .jiaoyan /deep/.el-date-editor {
    width: 150px!important;
  }
  /deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
  }
  .box{
    display: flex;
    justify-content: space-around;
    .imgBox{
      display: flex;
      flex-direction: column;
      width: 386px;
      /deep/.el-upload--picture-card{
        width: 386px;
        height: 240px;
      }
    }
    h6{
      text-align: center;
    }
    /deep/.el-upload--picture-card {
      background-image: url(../../../assets/images/upload1.png);
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item{
      width: 386px;
      height: 240px;
    }
  }
  .loogImgBox{
    display: flex;
    justify-content: space-around;
    .box1{
      width: 48%;
    }
    img{
      width: 100%;
    }
  }

  /deep/.inpBox .bigInp .el-input__inner{
    width: 250px;
  }
  .hidden /deep/.el-upload--picture-card{
      display: none;
    }
   .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
